module.exports = __webpack_public_path__ + "img/Partners 7.edb32004.png";